import { render, staticRenderFns } from "./Bar.vue?vue&type=template&id=41b4fb90&scoped=true"
import script from "./Bar.vue?vue&type=script&lang=js"
export * from "./Bar.vue?vue&type=script&lang=js"
import style0 from "./Bar.vue?vue&type=style&index=0&id=41b4fb90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b4fb90",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsTimer: require('/home/ticketshoplv/public_html/ticketshop.lt/components/elements/Timer.vue').default})
